module.exports = __webpack_public_path__ + "static/img/jiaodai2.caddbc2.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/jiaodai2.png
// module id = SmCF
// module chunks = 1